import { BaseApi } from './base.api.js';

export class CommunicationPlanApi extends BaseApi {
    constructor(client, basePath = '/communication-plan') {
        super(client, basePath);
    }

    async getPartyTemplate(params = {}) {
        const response = await this.client.get(`${this.basePath}/party-template`, { params });
        return response.data;
    }

    async getParty(id) {
        const response = await this.client.get(`${this.basePath}/${id}/party`);
        return response.data;
    }

    async syncParty(id, body) {
        const response = await this.client.put(`${this.basePath}/${id}/party`, body);
        return response.data;
    }
}
